export default __webpack_public_path__ + "static/media/GreycliffCF-Regular.2d532983.ttf";